

// import React, { useEffect, useState, useRef } from 'react';
// import ToolDesignBanner from './ToolDesignBanner';
// import BannerDFS from './BannerDFS';
// import BannerVR from './BannerVR';
// import VirtualRoboticsPage from './VirtualRoboticsPage';
// import DigitalFacilitiesSolutionPage from './DigitalFacilitiesSolutionPage';
// import FlutterTabs from './FlutterTabs';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import Slider from 'react-slick';
// import Whyattend from './Whyattend';
// import { faHome, faHospital, faMicrochip } from '@fortawesome/free-solid-svg-icons';
// import ProgramFeesAndSchedules from './ProgramFeesAndSchedules';
// import KeyFuturesSectionVR from './KeyFuturesSectionVR';
// import CertificationVR from './CertificationVR';
// import LearningPathVR from './LearningPathVR';
// import SkilledUniversitiesVR from './SkilledUniversitiesVR';
// import ToolCoveredImgesVR from './ToolCoveredImgesVR';
// import Informationtec from './Informationtec';
// import Reactbanner from './Reactbanner';
// import Toolfixturebanner from './Toolfixturebanner';
// import Digitalfactory from './Digitalfactory';
// import Pythonbanner from './Pythonbanner';
// import Fluuterbanner from './Fluuterbanner';
// import {
//   faCogs,          // For Mechanical
//   faIndustry,      // For Digital Factory
//   faFire,
//   faLaptopCode,          // Replacing Laptop Code with Fire (for Josh)
// } from '@fortawesome/free-solid-svg-icons';

// // import ProgramFeesAndSchedules from './ProgramFeesAndSchedules';
// import KeyFuturesSectionDFS from './KeyFuturesSectionDFS';
// import CertificationDFS from './CertificationDFS';
// import LearningPathDFS from './LearningPathDFS';
// import SkilledUniversitiesDFS from './SkilledUniversitiesDFS';
// import ToolCoveredImgesDFS from './ToolCoveredImgesDFS';
// import Vurtualroboticsdata from './Vurtualroboticsdata'
// import ToolandFixtureData from './ToolandFixtureData'
// import DigitalFactoryData from './DigitalFactoryData'

// // import ProgramFeesAndSchedules from './ProgramFeesAndSchedules';
// import KeyFuturesSection from './KeyFuturesSection';
// import CertificationTFD from './CertificationTFD';
// import LearningPathTFD from './LearningPathTFD';
// import SkilledUniversities from './SkilledUniversities';
// import ToolCoveredImges from './ToolCoveredImges';
// import WorkshoapBanner from './WorkshoapBanner';
// import Datavideos from './Datavideos';
// import VertualroboticsBanner from './VertualroboticsBanner';

// import Outdoor from './Outdoor'
// import DigitalFacilityBanner from './DigitalFacilityBanner';
// import VirtualroboticscertificationBanner from './VirtualroboticscertificationBanner';
// import VirtualRobotsBannerInternship from './VirtualRobotsBannerInternship';
// import VrCertificationcode from './VrCertificationcode';
// import VrCertificationInternship from './VrCertificationInternship';
// import LearningPathDommy from './LearningPathDommy';
// import ToolAndFixtureworkshop from './ToolAndFixtureworkshop';
// import ToolAndFixtureInternship from './ToolAndFixtureInternship';
// import VirtualRoboticsSoftwaresBanners from './VirtualRoboticsSoftwaresBanners';
// import SoftwaresCertificates from './SoftwaresCertificates';
// import Module from './Module';
// import ModuleB from './ModuleB';
// import ModuleJose from './ModuleJose';
// import ModuleCM from './ModuleCM';
// import ModuleDM from './ModuleDM';
// import ModuleR from './ModuleR';
// import VirtualwebibarKeyfetures from './VirtualwebibarKeyfetures';
// import ModuleFactory from './ModuleFactory';
// import Digitalkey from'./Digitalkey';
// import ToolfixtureModule from'./ToolfixtureModule';
// import TollkeyFeatuare from'./TollkeyFeatuare';
// import PythanKeyfeature from './PythanKeyfeature';
// import PythonModule from './PythonModule';
// import JavaModule from'./JavaModule';
// import JavaKey from './JavaKey';
// import Flutterkey from './Flutterkey';
// import Fluttermodule from './Fluttermodule';
// import Reactkey from './Reactkey';
// import Reactmodule from './Reactmodule';
// import Careeerfoundmodule from'./Careeerfoundmodule';
// import CareerfoundKey from'./CareerfoundKey';
// import Softskillkey from'./Softskillkey';
// import Softskillmodule from './Softskillmodule';
// import Digitalpresencemodule from './Digitalpresencemodule';
// import Digitalprencekey from './Digitalprencekey';
// import Whyshudattandtool from'./Whyshudattandtool';
// import Whatwillgaintool from'./Whatwillgaintool';
// import Whowastoattandtool from './Whowastoattandtool';
// import Digitalwhyshudattand from'./Digitalwhyshudattand';
// import Whatwillgaindigital from './Whatwillgaindigital';
// import Whowasattanddigital from './Whowasattanddigital';
// import Whyshuldarrandjava from './Whyshuldarrandjava';
// import Whatwiilgainjava from './Whatwiilgainjava';
// import Whowasattandjava from './Whowasattandjava';
// import Whyshoudleranpython from './Whyshoudleranpython';
// import Whatwilllearnpython from './Whatwilllearnpython';
// import Whowastogainpython from'./Whowastogainpython';
// import Whyshouldattandfluuter from './Whyshouldattandfluuter';
// import Whatweleranflutter from'./Whatweleranflutter';
// import Whoshouldlearnflutter from'./Whoshouldlearnflutter';
// import Whyshouldattandreacr from'./Whyshouldattandreacr';
// import Whatwillgainreact from './Whatwillgainreact';
// import Whowaslearnreact from'./Whowaslearnreact';
// const PCMobileApplications = () => {
//   const [toggle, setToggle] = useState(1);
//   const [navbarHeight, setNavbarHeight] = useState(2); // Default navbar height
//   const [tabVR, setTabVR] = useState(2);
//   const [tabPages, setTabPages] = useState(1); // For new tab group
//   const [mainTab, setMainTab] = useState(2);
//   function updateTabsVR(num) {
//     setTabVR(num);
//   }
//   const [activeButton, setActiveButton] = useState(null);
 

//   const updateToggle = (id) => {
//     setActiveButton(id);  // Set the clicked button as active
//     setToggle(id);         // Set the toggle state
//   };
//   const updateMainTabs = (tabIndex) => {
//     setMainTab(tabIndex);
//   };




//   // Create a ref for the show-the-content container
//   const contentRef = useRef(null);

//   // Function to update sub-tabs and scroll smoothly
//   const handleSubTabClick = (tabNumber) => {
//     updateSubTabs(tabNumber); // Your existing function to update sub-tabs

//     // Scroll to the show-the-content container with an offset
//     setTimeout(() => {
//       if (contentRef.current) {
//         const offset = 180; // Adjust this value to control how much of the top you want to show
//         const elementPosition = contentRef.current.getBoundingClientRect().top + window.scrollY;
//         window.scrollTo({
//           top: elementPosition - offset,
//           behavior: 'smooth',
//         });
//       }
//     }, 0);
//   };




//   const updateSubTabs = (tabIndex) => {
//     setSubTab(tabIndex);
//   };

//   const tabContentRef = useRef(null);

//   const handleTabClick = (tabIndex) => {
//     // Scroll to the respective tab content section
//     if (tabContentRef.current) {
//       tabContentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     }
//   };




//   const [subTab, setSubTab] = useState(5);  // Default sub tab
//   // Handle main tab change
//   // const updateMainTabs = (tabId) => {
//   //   setMainTab(tabId);
//   //   scrollToTop(); // Scroll to top on main tab change
//   // };

//   // // Handle sub tab change
//   // const updateSubTabs = (tabId) => {
//   //   setSubTab(tabId);
//   //   scrollToTop(); // Scroll to top on sub tab change
//   // };

//   // Scroll to top function




  
 
//   const contentRefs = {
//     tab5: useRef(null),
//     tab2: useRef(null),
//     tab3: useRef(null),
//   };

//   const scrollToTop = (tabId) => {
//     if (contentRefs[tabId] && contentRefs[tabId].current) {
//       contentRefs[tabId].current.scrollIntoView({ behavior: 'smooth' });
//     }
//   };

//   useEffect(() => {
//     // Scroll to top on mount
//     window.scrollTo(0, 0);

//     // Calculate navbar height
//     const navbar = document.querySelector('.navbar');
//     if (navbar) {
//       setNavbarHeight(navbar.offsetHeight);
//     }
//   }, []);

//   const settingss = {
//     dots: false, // Show dots for navigation
//     infinite: true, // Enable infinite scrolling
//     arrows: false,
//     autoplay: true,
//     speed: 500, // Transition speed
//     slidesToShow: 3, // Number of items to show at once
//     slidesToScroll: 1, // Number of items to scroll per action
//     responsive: [
//       {
//         breakpoint: 768, // For screens smaller than 768px
//         settings: {
//           slidesToShow: 1, // Show 1 slide at a time
//           slidesToScroll: 1, // Scroll 1 slide at a time
//         },
//       },
//     ],
//   };

//   const settings = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     pauseOnHover: true,
//     arrows: false,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           arrows: false,
//         },
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           arrows: false,
//         },
//       },
//     ],
//   };

//   return (
//     <div style={{ backgroundColor: 'white' }}>
      
//       {/* Hero Section */}
//       <div className={toggle === 1 ? 'show-the-content' : 'dont-show-content'}>
       
//       </div>

//       <div className={toggle === 2 ? 'show-the-content' : 'dont-show-content'}>
       
//       </div>

//       <div className={toggle === 3 ? 'show-the-content' : 'dont-show-content'}>
      
//       </div>

     
//       <div>
       
//       </div>

//       <div style={{ backgroundColor: 'white' }}>




//         {/* <div
//           className="icon-slider-wrapper iconddd"
//           style={{
//             position: 'sticky',
//             top: 102,
//             backgroundColor: '#fff',
//             zIndex: 997,
//             height: '82px',
//             width: '105%',
//             maxWidth:'1234px',
//             margin: '0 auto',
//             justifyContent: 'space-between',
//             alignItems:'center',
          
//           }}
//         >
//           <Slider {...settings}>

//             <div style={{ textAlign: 'center' }}>
//             <a
//       className="filter inform"
//       onClick={() => updateToggle(3)}
//       style={{
//         textDecoration: 'none',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         marginTop: '20px',
//         width:'400px',
//         color: activeButton === 3 ? 'white' : 'white', // Orange text when inactive, white when active
//         // fontFamily: 'roboto',
//         fontSize: "20px",
//         fontWeight: "800",
//         padding: '10px 20px',
//         borderRadius: '15px',
//         backgroundColor: activeButton === 3 ? 'black' : 'blue', // Sky-blue background when inactive, blue when active
//         transform: activeButton === 3 ? 'translateY(-5px)' : 'none', // Button lifted when active
//         transition: 'color 0.3s ease, transform 0.3s ease, background-color 0.3s ease', // Smooth transition
//       }}
//       onMouseEnter={(e) => {
//         if (activeButton !== 3) { // Only apply hover effect if not active
//           e.target.style.color = 'white'; // Change text color to white on hover
//           e.target.style.backgroundColor = 'black'; // Change background to blue on hover
//           e.target.style.transform = 'translateY(-5px)'; // Lift the button on hover
//         }
//       }}
//       onMouseLeave={(e) => {
//         if (activeButton !== 3) { // Only reset hover effect if not active
//           e.target.style.color = 'white'; // Reset text color to orange
//           e.target.style.backgroundColor = 'blue'; // Reset background color to sky blue
//           e.target.style.transform = 'translateY(0)'; // Reset button position
//         }
//       }}
//     >
//      INFORMATION TECHNOLOGY
//     </a>
//             </div>


           
//             <div style={{ textAlign: 'center' }}>
//             <a
//       className="filter inform"
//       onClick={() => updateToggle(2)}
//       style={{
//         textDecoration: 'none',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         marginTop: '20px',
//         color: activeButton === 2 ? 'white' : 'white', // Orange text when inactive, white when active
//         // fontFamily: 'roboto',
//         fontSize: "20px",
//         fontWeight: "800",
//         width:'400px',
//         padding: '10px 20px',
//         borderRadius: '15px',
//         backgroundColor: activeButton === 2 ? 'black' : 'blue', // Sky-blue background when inactive, blue when active
//         transform: activeButton === 2 ? 'translateY(-5px)' : 'none', // Button lifted when active
//         transition: 'color 0.3s ease, transform 0.3s ease, background-color 0.3s ease', // Smooth transition
//       }}
//       onMouseEnter={(e) => {
//         if (activeButton !== 2) { // Only apply hover effect if not active
//           e.target.style.color = 'white'; // Change text color to white on hover
//           e.target.style.backgroundColor = 'black'; // Change background to blue on hover
//           e.target.style.transform = 'translateY(-5px)'; // Lift the button on hover
//         }
//       }}
//       onMouseLeave={(e) => {
//         if (activeButton !== 2) { // Only reset hover effect if not active
//           e.target.style.color = 'white'; // Reset text color to orange
//           e.target.style.backgroundColor = 'blue'; // Reset background color to sky blue
//           e.target.style.transform = 'translateY(0)'; // Reset button position
//         }
//       }}
//     >
//       JOB ORIENTED SKILL ENACHMENTS
//     </a>
//             </div>



//             <div style={{ textAlign: 'center' }}>
//             <a
//       className="filter inform"
//       onClick={() => updateToggle(1)}
//       style={{
//         textDecoration: 'none',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         marginTop: '20px',
//         color: activeButton === 1 ? 'white' : 'white', // Orange text when inactive, white when active
//         // fontFamily: 'roboto',
//         fontSize: "20px",
//         fontWeight: "800",
//         width:'400px',
//         padding: '10px 20px',
//         borderRadius: '15px',
//         backgroundColor: activeButton === 1 ? 'black' : 'blue', // Sky-blue background when inactive, blue when active
//         transform: activeButton === 1 ? 'translateY(-5px)' : 'none', // Button lifted when active
//         transition: 'color 0.3s ease, transform 0.3s ease, background-color 0.3s ease', // Smooth transition
//       }}
//       onMouseEnter={(e) => {
//         if (activeButton !== 1) { // Only apply hover effect if not active
//           e.target.style.color = 'white'; // Change text color to white on hover
//           e.target.style.backgroundColor = 'black'; // Change background to blue on hover
//           e.target.style.transform = 'translateY(-5px)'; // Lift the button on hover
//         }
//       }}
//       onMouseLeave={(e) => {
//         if (activeButton !== 1) { // Only reset hover effect if not active
//           e.target.style.color = 'white'; // Reset text color to orange
//           e.target.style.backgroundColor = 'blue'; // Reset background color to sky blue
//           e.target.style.transform = 'translateY(0)'; // Reset button position
//         }
//       }}
//     >
//       MECHANICAL ENGINEERING 
//     </a>
//             </div>
//           </Slider>
//         </div> */}
      
//         <div className={toggle === 3 ? 'show-the-content' : 'dont-show-content'}>
//           {/* <div> */}
        
//           <div
          
//               style={{
//                 position: 'sticky',
//                 top: '99px', // Fixed under the first sticky navbar
//                 backgroundColor: '#e7e7f3',
//                 // boxShadow: '222px 2px 5px rgba(0, 0, 0, 0.1)', // Correct box-shadow
//                 padding: '5px 0',
//                 zIndex: 999,
//                 width: '100%',
//                 marginTop:'-12px',
//               }}
//               className='itslider'
//             >
              
//               <ul
//                 style={{
//                   display: 'flex',
//                   justifyContent: 'center',
//                   listStyle: 'none',
//                   margin: 22, // Remove extra margin for precise spacing
//                   padding: 0,
//                   gap: '20px', // Add 20px gap between items
//                   marginBottom: '2px',
//                   flexWrap: 'wrap', // Allow wrapping for smaller screens
//                 }}
//               >
                
//                <li
//       onClick={() => updateMainTabs(2)}
//       style={{
//         fontSize: "20px",
//         fontWeight: "800",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "10px 30px",
//         backgroundColor: mainTab === 2 ? "orange" : "#000", // Active tab has white background
//         color: mainTab === 2 ? "black" : "orange", // Active tab has black text color
//         cursor: "pointer",
//         borderRadius: "15px",
//         marginBottom: "10px", // Add spacing for wrapped items
//         position: "relative",
//         transition: "all 0.3s ease", // Smooth transition for all changes
//         transform: mainTab === 2 ? "translateY(-5px)" : "translateY(0)", // Button moves up when selected
//         zIndex: mainTab === 2 ? 1 : 0, // Ensure the active tab stays on top
//       }}
//       onMouseEnter={(e) => {
//         // Change background and text color when hovered, if not active
//         if (mainTab !== 2) {
//           e.target.style.backgroundColor = "orange";
//           e.target.style.color = "black";
//           e.target.style.transform = "translateY(-5px)"; // Move the button up when hovered
//         }
//       }}
//       onMouseLeave={(e) => {
//         // Reset to original colors if not active
//         if (mainTab !== 2) {
//           e.target.style.backgroundColor = "#000"; // Reset to original background
//           e.target.style.color = "orange"; // Reset text color
//           e.target.style.transform = "translateY(0)"; // Reset button position
//         }
//       }}
//     >
//       JAVA
//     </li>

//     <li
//       onClick={() => updateMainTabs(9)}
//       style={{
//         fontSize: "20px",
//         fontWeight: "800",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "10px 30px",
//         backgroundColor: mainTab === 9 ? "orange" : "#000", // Active tab has white background
//         color: mainTab === 9 ? "black" : "orange", // Active tab has black text color
//         cursor: "pointer",
//         borderRadius: "15px",
//         marginBottom: "10px", // Add spacing for wrapped items
//         position: "relative",
//         transition: "all 0.3s ease", // Smooth transition for all changes
//         transform: mainTab === 9 ? "translateY(-5px)" : "translateY(0)", // Button moves up when selected
//         zIndex: mainTab === 9 ? 1 : 0, // Ensure the active tab stays on top
//       }}
//       onMouseEnter={(e) => {
//         // Change background and text color when hovered, if not active
//         if (mainTab !== 9) {
//           e.target.style.backgroundColor = "orange";
//           e.target.style.color = "black";
//           e.target.style.transform = "translateY(-5px)"; // Move the button up when hovered
//         }
//       }}
//       onMouseLeave={(e) => {
//         // Reset to original colors if not active
//         if (mainTab !== 9) {
//           e.target.style.backgroundColor = "#000"; // Reset to original background
//           e.target.style.color = "orange"; // Reset text color
//           e.target.style.transform = "translateY(0)"; // Reset button position
//         }
//       }}
//     >
//                  REACT.JS
//                 </li>

//                 <li
//       onClick={() => updateMainTabs(3)}
//       style={{
//         fontSize: "20px",
//         fontWeight: "800",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "10px 30px",
//         backgroundColor: mainTab === 3 ? "orange" : "#000", // Active tab has white background
//         color: mainTab === 3 ? "black" : "orange", // Active tab has black text color
//         cursor: "pointer",
//         borderRadius: "15px",
//         marginBottom: "10px", // Add spacing for wrapped items
//         position: "relative",
//         transition: "all 0.3s ease", // Smooth transition for all changes
//         transform: mainTab === 3 ? "translateY(-5px)" : "translateY(0)", // Button moves up when selected
//         zIndex: mainTab === 3 ? 1 : 0, // Ensure the active tab stays on top
//       }}
//       onMouseEnter={(e) => {
//         // Change background and text color when hovered, if not active
//         if (mainTab !== 3) {
//           e.target.style.backgroundColor = "orange";
//           e.target.style.color = "black";
//           e.target.style.transform = "translateY(-5px)"; // Move the button up when hovered
//         }
//       }}
//       onMouseLeave={(e) => {
//         // Reset to original colors if not active
//         if (mainTab !== 3) {
//           e.target.style.backgroundColor = "#000"; // Reset to original background
//           e.target.style.color = "orange"; // Reset text color
//           e.target.style.transform = "translateY(0)"; // Reset button position
//         }
//       }}
//     >
//                  PYTHON
//                 </li>
//  <li
//       onClick={() => updateMainTabs(4)}
//       style={{
//         fontSize: "20px",
//         fontWeight: "800",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "10px 30px",
//         backgroundColor: mainTab === 4 ? "orange" : "#000", // Active tab has white background
//         color: mainTab === 4 ? "black" : "orange", // Active tab has black text color
//         cursor: "pointer",
//         borderRadius: "15px",
//         marginBottom: "10px", // Add spacing for wrapped items
//         position: "relative",
//         transition: "all 0.3s ease", // Smooth transition for all changes
//         transform: mainTab === 4 ? "translateY(-5px)" : "translateY(0)", // Button moves up when selected
//         zIndex: mainTab === 4 ? 1 : 0, // Ensure the active tab stays on top
//       }}
//       onMouseEnter={(e) => {
//         // Change background and text color when hovered, if not active
//         if (mainTab !== 3) {
//           e.target.style.backgroundColor = "orange";
//           e.target.style.color = "black";
//           e.target.style.transform = "translateY(-5px)"; // Move the button up when hovered
//         }
//       }}
//       onMouseLeave={(e) => {
//         // Reset to original colors if not active
//         if (mainTab !== 4) {
//           e.target.style.backgroundColor = "#000"; // Reset to original background
//           e.target.style.color = "orange"; // Reset text color
//           e.target.style.transform = "translateY(0)"; // Reset button position
//         }
//       }}
//     >
//                  FLUTTER
//                 </li>
                
//               </ul>
             
//             </div>

//             <div
//               style={{
//                 position: "sticky",
//                 top: "172px", // Fixed under the first sticky navbar
//                 // backgroundColor: '#e1d9d9',
//                 padding: "5px 0",
//                 zIndex: 997,
//                 width: "100%",
//               }}
//               className='secondslickslider'
//              >
//               <Slider {...settingss}>
//                 <div>
//                   <li
//                     onClick={() => updateMainTabs(2)}
//                     style={{
//                       fontSize: "20px",
//                       fontWeight: "800",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       padding: "10px 30px",
//                       backgroundColor: mainTab === 2 ? "black" : "#000",
//                       color: mainTab === 2 ? "orange" : "orange",
//                       cursor: "pointer",
//                       borderRadius: "15px",
//                       marginBottom: "10px", // Add spacing for wrapped items
//                     }}
//                   >
//                     JAVA
//                   </li>
//                 </div>

//                 <div>
//                   <li
//                     onClick={() => updateMainTabs(9)}
//                     style={{
//                       fontSize: "20px",
//                       fontWeight: "800",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       padding: "10px 30px",
//                       backgroundColor: mainTab === 9 ? "black" : "#000",
//                       color: mainTab === 9 ? "orange" : "orange",
//                       cursor: "pointer",
//                       borderRadius: "15px",
//                       marginBottom: "10px",
//                     }}
//                   >
//                     REACT.JS
//                   </li>
//                 </div>

//                 <div>
//                   <li
//                     onClick={() => updateMainTabs(3)}
//                     style={{
//                       fontSize: "20px",
//                       fontWeight: "800",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       padding: "10px 30px",
//                       backgroundColor: mainTab === 3 ? "black" : "#000",
//                       color: mainTab === 3 ? "orange" : "orange",
//                       cursor: "pointer",
//                       borderRadius: "15px",
//                       marginBottom: "10px",
//                     }}
//                   >
//                    PYTHON
//                   </li>
                  
//                 </div>

//                 <div>
//                   <li
//                     onClick={() => updateMainTabs(4)}
//                     style={{
//                       fontSize: "20px",
//                       fontWeight: "800",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       padding: "10px 30px",
//                       backgroundColor: mainTab === 4 ? "black" : "#000",
//                       color: mainTab === 4 ? "orange" : "orange",
//                       cursor: "pointer",
//                       borderRadius: "15px",
//                       marginBottom: "10px",
//                     }}
//                   >
//                   FLUTTER
//                   </li>
                  
//                 </div>

//               </Slider>
//             </div>

           
         

           

//           <div className={mainTab === 2 ? 'show-the-content' : 'dont-show-content'}>
//             {/* <VertualroboticsBanner /> */}
//             {/* <Informationtec/> */}
//             {/* <KeyFuturesSectionVR /> */}
//             <JavaKey/>
//             <JavaModule/>
//             <Whyshuldarrandjava />
//             <Whatwiilgainjava />
//             <Whowasattandjava />
//             <ToolCoveredImgesVR />
//             {/* <Datavideos /> */}
//           </div>
//           <div className={mainTab === 9 ? 'show-the-content' : 'dont-show-content'}>
 
//                   <Reactkey/>
//                   <Reactmodule/>
//                   <Whyshouldattandreacr />
//                   <Whatwillgainreact />
//             <Whowaslearnreact/>
//             <ToolCoveredImgesVR />
//             {/* <Datavideos /> */}
//           </div>

//           <div className={mainTab === 3 ? 'show-the-content' : 'dont-show-content'}>
//             {/* <VertualroboticsBanner /> */}
//             {/* <Pythonbanner/> */}
//             {/* <KeyFuturesSectionVR /> */}
//             <PythanKeyfeature/>
//             <PythonModule/>
//             <Whyshoudleranpython />
           
//             <Whatwilllearnpython />
//             <Whowastogainpython />
//             <ToolCoveredImgesVR />
//             {/* <CertificationVR /> */}
//           </div>

         

//           <div className={mainTab === 4 ? 'show-the-content' : 'dont-show-content'}>
//             {/* <VertualroboticsBanner /> */}
//              {/* <Fluuterbanner/> */}
//              <Flutterkey/>
//              <Fluttermodule/>
//              <Whyshouldattandfluuter />
//              <Whatweleranflutter />
//             <Whoshouldlearnflutter />
//             <ToolCoveredImgesVR />
//             {/* <LearningPathVR /> */}
          
//           </div>
          
//         </div>
       







//         {/* Outdoor.js, PlacementCards.js, OurTeamsAdd.js, OurCoPartners.js, NewaboutwhychosesUS.js, 11111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111 */}




       



//         <div className={toggle === 2 ? 'show-the-content' : 'dont-show-content'}>
//           <div>
//             {/* Main Tabs */}
//             <div className="reCreateTabs" style={{
//               position: 'sticky',
//               top: '172px',
//               // top: `${navbarHeight + 100}px`,
//               backgroundColor: '#fff',
//               padding: '5px 0',
//               marginTop:'80px',
//               zIndex: 998,
//             }}>
//               <ul style={{ display: 'flex', listStyle: 'none', margin: 22, padding: 0, marginBottom: 2, }}>
              
//               <li
//       onClick={() => updateMainTabs(2)}
//       style={{
//         fontSize: "20px",
//         fontWeight: "800",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "10px 30px",
//         backgroundColor: mainTab === 2 ? "orange" : "#000", // Active tab has white background
//         color: mainTab === 2 ? "black" : "orange", // Active tab has black text color
//         cursor: "pointer",
//         borderRadius: "15px",
//         marginBottom: "10px", // Add spacing for wrapped items
//         position: "relative",
//         transition: "all 0.3s ease", // Smooth transition for all changes
//         transform: mainTab === 2 ? "translateY(-5px)" : "translateY(0)", // Button moves up when selected
//         zIndex: mainTab === 2 ? 1 : 0, // Ensure the active tab stays on top
//       }}
//       onMouseEnter={(e) => {
//         // Change background and text color when hovered, if not active
//         if (mainTab !== 2) {
//           e.target.style.backgroundColor = "orange";
//           e.target.style.color = "black";
//           e.target.style.transform = "translateY(-5px)"; // Move the button up when hovered
//         }
//       }}
//       onMouseLeave={(e) => {
//         // Reset to original colors if not active
//         if (mainTab !== 2) {
//           e.target.style.backgroundColor = "#000"; // Reset to original background
//           e.target.style.color = "orange"; // Reset text color
//           e.target.style.transform = "translateY(0)"; // Reset button position
//         }
//       }}
//     >
//                  CAREER FOUNDATION SKILLS
//                 </li>
              

//                 <li
//       onClick={() => updateMainTabs(3)}
//       style={{
//         fontSize: "20px",
//         fontWeight: "800",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "10px 30px",
//         backgroundColor: mainTab === 3 ? "orange" : "#000", // Active tab has white background
//         color: mainTab === 3 ? "black" : "orange", // Active tab has black text color
//         cursor: "pointer",
//         borderRadius: "15px",
//         marginBottom: "10px", // Add spacing for wrapped items
//         position: "relative",
//         transition: "all 0.3s ease", // Smooth transition for all changes
//         transform: mainTab === 3 ? "translateY(-5px)" : "translateY(0)", // Button moves up when selected
//         zIndex: mainTab === 3 ? 1 : 0, // Ensure the active tab stays on top
//       }}
//       onMouseEnter={(e) => {
//         // Change background and text color when hovered, if not active
//         if (mainTab !== 3) {
//           e.target.style.backgroundColor = "orange";
//           e.target.style.color = "black";
//           e.target.style.transform = "translateY(-5px)"; // Move the button up when hovered
//         }
//       }}
//       onMouseLeave={(e) => {
//         // Reset to original colors if not active
//         if (mainTab !== 3) {
//           e.target.style.backgroundColor = "#000"; // Reset to original background
//           e.target.style.color = "orange"; // Reset text color
//           e.target.style.transform = "translateY(0)"; // Reset button position
//         }
//       }}
//     >
//                   SOFT SKILLS DEVELOPMENT
//                 </li>


//                 <li
//       onClick={() => updateMainTabs(4)}
//       style={{
//         fontSize: "20px",
//         fontWeight: "800",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "10px 30px",
//         backgroundColor: mainTab === 4 ? "orange" : "#000", // Active tab has white background
//         color: mainTab === 4 ? "black" : "orange", // Active tab has black text color
//         cursor: "pointer",
//         borderRadius: "15px",
//         marginBottom: "10px", // Add spacing for wrapped items
//         position: "relative",
//         transition: "all 0.3s ease", // Smooth transition for all changes
//         transform: mainTab === 4 ? "translateY(-5px)" : "translateY(0)", // Button moves up when selected
//         zIndex: mainTab === 4 ? 1 : 0, // Ensure the active tab stays on top
//       }}
//       onMouseEnter={(e) => {
//         // Change background and text color when hovered, if not active
//         if (mainTab !== 4) {
//           e.target.style.backgroundColor = "orange";
//           e.target.style.color = "black";
//           e.target.style.transform = "translateY(-5px)"; // Move the button up when hovered
//         }
//       }}
//       onMouseLeave={(e) => {
//         // Reset to original colors if not active
//         if (mainTab !== 4) {
//           e.target.style.backgroundColor = "#000"; // Reset to original background
//           e.target.style.color = "orange"; // Reset text color
//           e.target.style.transform = "translateY(0)"; // Reset button position
//         }
//       }}
//     >
//                    DIGITAL PRESENCE SKILLS
//                 </li>
//               </ul>
//             </div>

//             <div
//               style={{
//                 position: "sticky",
//                 top: "172px", // Fixed under the first sticky navbar
//                 // backgroundColor: '#e1d9d9',
//                 padding: "5px 0",
//                 zIndex: 997,
//                 width: "100%",
//               }}
//               className='secondslickslider'
//              >
//               <Slider {...settingss}>
//                 <div>
//                   <li
//                     onClick={() => updateMainTabs(2)}
//                     style={{
//                       fontSize: "20px",
//                       fontWeight: "800",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       padding: "10px 30px",
//                       backgroundColor: mainTab === 2 ? "black" : "#000",
//                       color: mainTab === 2 ? "orange" : "orange",
//                       cursor: "pointer",
//                       borderRadius: "15px",
//                       marginBottom: "10px", // Add spacing for wrapped items
//                     }}
//                   >
//                     CAREER FOUNDATION SKILLS
//                   </li>
//                 </div>

//                 <div>
//                   <li
//                     onClick={() => updateMainTabs(3)}
//                     style={{
//                       fontSize: "20px",
//                       fontWeight: "800",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       padding: "10px 30px",
//                       backgroundColor: mainTab === 3 ? "black" : "#000",
//                       color: mainTab === 3 ? "orange" : "orange",
//                       cursor: "pointer",
//                       borderRadius: "15px",
//                       marginBottom: "10px",
//                     }}
//                   >
//                   SOFT SKILLS DEVELOPMENT
//                   </li>
//                 </div>

//                 <div>
//                   <li
//                     onClick={() => updateMainTabs(4)}
//                     style={{
//                       fontSize: "20px",
//                       fontWeight: "800",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       padding: "10px 30px",
//                       backgroundColor: mainTab === 4 ? "black" : "#000",
//                       color: mainTab === 4? "orange" : "orange",
//                       cursor: "pointer",
//                       borderRadius: "15px",
//                       marginBottom: "10px",
//                     }}
//                   >
//                  DIGITAL PRESENCE SKILLS
//                   </li>
                  
//                 </div>

                
//               </Slider>
//             </div>

           

//             {/* Content Sections - Main Tab 2 (Virtual Robotics) */}

//             <>
//               {/* {mainTab === 2 && subTab === 2 && (
//                 <div ref={contentRef} className="show-the-content">

                 
//                   <KeyFuturesSectionVR />
//                   <ModuleJose />
                 

//                   <ProgramFeesAndSchedules />
//                   <SkilledUniversitiesVR />
//                   <ToolCoveredImgesVR />
//                 </div>
//               )} */}
// {/*               
//               {mainTab === 2 && (
//                 <div ref={contentRef} className="show-the-content">
//                   Virtual Robotics - Workshop
//                   <WorkshoapBanner />
//                   <Vurtualroboticsdata />
//                   <KeyFuturesSectionVR />
//                   <LearningPathVR />
//                   <ProgramFeesAndSchedules />
//                   <SkilledUniversitiesVR />
//                   <ToolCoveredImgesVR />
//                   <CertificationVR />
//                 </div>
//               )} */}


//               {mainTab === 4 && (
//                 <div ref={contentRef} className="show-the-content">
                
//                   <Digitalprencekey/>
//                 <Digitalpresencemodule/>
//                 <Whyattend />
//                   <ProgramFeesAndSchedules />
//                   <SkilledUniversitiesVR />
//                   <ToolCoveredImgesVR />
//                   {/* <CertificationVR /> */}
//                   {/* <VrCertificationcode /> */}
//                 </div>
//               )}
//               {mainTab === 2 && (
//                 <div ref={contentRef} className="show-the-content">
                 
//                   {/* <Vurtualroboticsdata /> */}
//                   {/* <VirtualRobotsBannerInternship /> */}
//                   <CareerfoundKey/>
//                   <Careeerfoundmodule/>

//                  <Whyattend />
//                   {/* <LearningPathVR /> */}
//                   <ProgramFeesAndSchedules />
//                   <SkilledUniversitiesVR />
//                   <ToolCoveredImgesVR />
//                   {/* <VrCertificationInternship /> */}
//                 </div>
//               )}

//             </>



//             {mainTab === 3 && (
//               <>
//                 {subTab === 5 && (
//                   <div className="show-the-content">

//                     {/* <DigitalFacilityBanner /> */}
                      
//                      <Softskillkey/>
//                      <Softskillmodule/>
//                      <Whyattend />
//                     {/* <LearningPathDFS /> */}
//                     <ProgramFeesAndSchedules />
//                     <SkilledUniversitiesVR />
//                     <ToolCoveredImgesVR />
                   
//                   </div>
//                 )}


// {/*                 
//                 {subTab === 17 && (
//                   <div className="show-the-content">

//                     <DigitalFacilityBanner />
//                     <KeyFuturesSectionDFS />
//                     <LearningPathDFS />
//                     <ProgramFeesAndSchedules />
//                     <SkilledUniversitiesDFS />
//                     <ToolCoveredImgesDFS />

//                     <CertificationDFS />
//                   </div>
//                 )} */}
//                 {/* {subTab === 7 && (
//                   <div className="show-the-content">

//                     <DigitalFacilityBanner />
//                     <KeyFuturesSectionDFS />
//                     <LearningPathDFS />
//                     <ProgramFeesAndSchedules />
//                     <SkilledUniversitiesDFS />
//                     <ToolCoveredImgesDFS />

//                     <CertificationDFS />
//                   </div>
//                 )} */}
//                 {/* {subTab === 4 && (
//                   <div className="show-the-content">

//                     <DigitalFacilityBanner />
//                     <KeyFuturesSectionDFS />
//                     <LearningPathDFS />
//                     <ProgramFeesAndSchedules />
//                     <SkilledUniversitiesDFS />
//                     <ToolCoveredImgesDFS />

//                     <CertificationDFS />
//                   </div>
//                 )} */}
//               </>
//             )}
//           </div>

//         </div>






//         {/* 11111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111 */}




//         <div className={toggle === 1 ? 'show-the-content' : 'dont-show-content'}>
//           <div>

//             <div className="reCreateTabs" style={{
//               position: 'sticky',
//               top: `${navbarHeight + 2}px`,
//               backgroundColor: '#fff',
//               // padding: '10px 0',
//               zIndex: 996,
              
//             }}>
//               <ul style={{ display: 'flex', listStyle: 'none', margin: 0, padding: 0 }}>
                
               

//               </ul>
//             </div>

//             {/* Second Sticky Navbar */}
//             {/* <div
//               style={{
//                 position: 'sticky',
//                 top: '99px', // Fixed under the first sticky navbar
//                 backgroundColor: 'rgb(231, 231, 243)',
            
//                 padding: '5px 0',
//                 zIndex: 997,
//                 width: '100%',
//                 marginTop:'-12px',
//               }}
//               className='firstlickslider'
//             >
//               <ul
//                 style={{
//                   display: 'flex',
//                   justifyContent: 'center',
//                   listStyle: 'none',
//                   margin: 22, // Remove extra margin for precise spacing
//                   padding: 0,
//                   gap: '20px', // Add 20px gap between items
//                   marginBottom: '2px',
//                   flexWrap: 'wrap', // Allow wrapping for smaller screens
//                 }}
//               >
//                <li
//       onClick={() => updateMainTabs(2)}
//       style={{
//         fontSize: "17px",
//         fontWeight: "800",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "10px 30px",
//         backgroundColor: mainTab === 2 ? "orange" : "#000", // Active tab has white background
//         color: mainTab === 2 ? "black" : "orange", // Active tab has black text color
//         cursor: "pointer",
//         borderRadius: "15px",
//         marginBottom: "10px", // Add spacing for wrapped items
//         position: "relative",
//         transition: "all 0.3s ease", // Smooth transition for all changes
//         transform: mainTab === 2 ? "translateY(-5px)" : "translateY(0)", // Button moves up when selected
//         zIndex: mainTab === 2 ? 1 : 0, // Ensure the active tab stays on top
//       }}
//       onMouseEnter={(e) => {
     
//         if (mainTab !== 2) {
//           e.target.style.backgroundColor = "orange";
//           e.target.style.color = "black";
//           e.target.style.transform = "translateY(-5px)"; // Move the button up when hovered
//         }
//       }}
//       onMouseLeave={(e) => {
      
//         if (mainTab !== 2) {
//           e.target.style.backgroundColor = "#000"; // Reset to original background
//           e.target.style.color = "orange"; // Reset text color
//           e.target.style.transform = "translateY(0)"; // Reset button position
//         }
//       }}
//     >
//       VIRTUAL SIMULATION
//     </li>

//     <li
//       onClick={() => updateMainTabs(5)}
//       style={{
//         fontSize: "17px",
//         fontWeight: "800",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "10px 30px",
//         backgroundColor: mainTab === 5 ? "orange" : "#000", // Active tab has white background
//         color: mainTab === 5 ? "black" : "orange", // Active tab has black text color
//         cursor: "pointer",
//         borderRadius: "15px",
//         marginBottom: "10px", // Add spacing for wrapped items
//         position: "relative",
//         transition: "all 0.3s ease", // Smooth transition for all changes
//         transform: mainTab === 5 ? "translateY(-5px)" : "translateY(0)", // Button moves up when selected
//         zIndex: mainTab === 5 ? 1 : 0, // Ensure the active tab stays on top
//       }}
//       onMouseEnter={(e) => {
      
//         if (mainTab !== 2) {
//           e.target.style.backgroundColor = "orange";
//           e.target.style.color = "black";
//           e.target.style.transform = "translateY(-5px)"; // Move the button up when hovered
//         }
//       }}
//       onMouseLeave={(e) => {
       
//         if (mainTab !== 5) {
//           e.target.style.backgroundColor = "#000"; // Reset to original background
//           e.target.style.color = "orange"; // Reset text color
//           e.target.style.transform = "translateY(0)"; // Reset button position
//         }
//       }}
//     >
//                   TOOL & FIXTURE DESIGN
//                 </li>

//                 <li
//       onClick={() => updateMainTabs(3)}
//       style={{
//         fontSize: "17px",
//         fontWeight: "800",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "10px 30px",
//         backgroundColor: mainTab === 3 ? "orange" : "#000", // Active tab has white background
//         color: mainTab === 3 ? "black" : "orange", // Active tab has black text color
//         cursor: "pointer",
//         borderRadius: "15px",
//         marginBottom: "10px", // Add spacing for wrapped items
//         position: "relative",
//         transition: "all 0.3s ease", // Smooth transition for all changes
//         transform: mainTab === 3 ? "translateY(-5px)" : "translateY(0)", // Button moves up when selected
//         zIndex: mainTab === 3 ? 1 : 0, // Ensure the active tab stays on top
//       }}
//       onMouseEnter={(e) => {
       
//         if (mainTab !== 3) {
//           e.target.style.backgroundColor = "orange";
//           e.target.style.color = "black";
//           e.target.style.transform = "translateY(-5px)"; // Move the button up when hovered
//         }
//       }}
//       onMouseLeave={(e) => {
      
//         if (mainTab !== 3) {
//           e.target.style.backgroundColor = "#000"; // Reset to original background
//           e.target.style.color = "orange"; // Reset text color
//           e.target.style.transform = "translateY(0)"; // Reset button position
//         }
//       }}
//     >
//                   DIGITAL FACTORY SOLUTION
//                 </li>
//               </ul>
//             </div> */}







//             {/* <div
//               style={{
//                 position: "sticky",
//                 top: "172px", // Fixed under the first sticky navbar
//                 // backgroundColor: '#e1d9d9',
//                 padding: "5px 0",
//                 zIndex: 997,
//                 width: "100%",
//               }}
//               className='secondslickslider'
//              >
//               <Slider {...settingss}>
//                 <div>
//                   <li
//                     onClick={() => updateMainTabs(2)}
//                     style={{
//                       fontSize: "20px",
//                       fontWeight: "800",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       padding: "10px 30px",
//                       backgroundColor: mainTab === 2 ? "black" : "#000",
//                       color: mainTab === 2 ? "orange" : "orange",
//                       cursor: "pointer",
//                       borderRadius: "15px",
//                       marginBottom: "10px", // Add spacing for wrapped items
//                     }}
//                   >
//                     VIRTUAL SIMULATION
//                   </li>
//                 </div>

//                 <div>
//                   <li
//                     onClick={() => updateMainTabs(5)}
//                     style={{
//                       fontSize: "20px",
//                       fontWeight: "800",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       padding: "10px 30px",
//                       backgroundColor: mainTab === 5 ? "black" : "#000",
//                       color: mainTab === 5 ? "orange" : "orange",
//                       cursor: "pointer",
//                       borderRadius: "15px",
//                       marginBottom: "10px",
//                     }}
//                   >
//                     TOOL & FIXTURE DESIGN
//                   </li>
//                 </div>

//                 <div>
//                   <li
//                     onClick={() => updateMainTabs(3)}
//                     style={{
//                       fontSize: "20px",
//                       fontWeight: "800",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       padding: "10px 30px",
//                       backgroundColor: mainTab === 3 ? "black" : "#000",
//                       color: mainTab === 3 ? "orange" : "orange",
//                       cursor: "pointer",
//                       borderRadius: "15px",
//                       marginBottom: "10px",
//                     }}
//                   >
//                     DIGITAL FACTORY SOLUTION
//                   </li>
//                 </div>
//               </Slider>
//             </div> */}






//             <div className="reCreateTabs  dfs all-data-tabs" style={{
//               position: 'sticky',
//               top: `${navbarHeight + 100}px`,
//               backgroundColor: '#fff',
//               // padding: '10px 0',
//               zIndex: 998,
//             }}>
//               <ul style={{ display: 'flex', listStyle: 'none', margin: 0, padding: 0 }}>
//                 {/* <li
//                   onClick={() => handleSubTabClick(5)}
//                   style={{
//                     fontSize: '20px',
//                     fontWeight: '800',
//                     padding: '10px 50px',
//                     backgroundColor: subTab === 5 ? 'gray' : '#e1d9d9',
//                     color: subTab === 5 ? 'orange' : 'black',
//                     cursor: 'pointer',
//                     borderRadius: '15px',
//                   }}
//                 >
//                   WEBINAR
//                 </li> */}
//                 {/* <li
//                   onClick={() => handleSubTabClick(6)}
//                   style={{
//                     fontSize: '20px',
//                     fontWeight: '800',
//                     padding: '10px 50px',
//                     backgroundColor: subTab === 6 ? 'gray' : '#e1d9d9',
//                     color: subTab === 6 ? 'orange' : 'black',
//                     cursor: 'pointer',
//                     borderRadius: '15px',
//                   }}
//                 >
//                   WORKSHOP
//                 </li> */}
//                 {/* <li
//                   onClick={() => handleSubTabClick(7)}
//                   style={{
//                     fontSize: '20px',
//                     fontWeight: '800',
//                     padding: '10px 50px',
//                     backgroundColor: subTab === 7 ? 'gray' : '#e1d9d9',
//                     color: subTab === 7 ? 'orange' : 'black',
//                     cursor: 'pointer',
//                     borderRadius: '15px',
//                   }}
//                 >
//                   CERTIFICATION
//                 </li> */}
//                 {/* <li
//                   onClick={() => handleSubTabClick(4)}
//                   style={{
//                     fontSize: '20px',
//                     fontWeight: '800',
//                     padding: '10px 50px',
//                     backgroundColor: subTab === 4 ? 'gray' : '#e1d9d9',
//                     color: subTab === 4 ? 'orange' : 'black',
//                     cursor: 'pointer',
//                     borderRadius: '15px',
//                   }}
//                 >
//                   INTERNSHIP
//                 </li> */}


//               </ul>
//             </div>

//             {/* Content Sections - Main Tab 5 (Tool and Fixture Design) */}


//             {/* Content Sections - Main Tab 2 (Virtual Robotics) */}

//             {mainTab === 2 && subTab === 5 && (
//               <div ref={contentRef} className="show-the-content">
//                 {/* Virtual Robotics - Webinar */}
//                 {/* <VertualroboticsBanner /> */}

//                 <VirtualwebibarKeyfetures />
//                 {/* <ModuleCM/> */}
//                 <ModuleR />
//                 <ModuleDM />
//                 {/* <ModuleR/> */}
//                 <Module />
//                 <ModuleB />
//                 {/* <LearningPathDommy /> */}
//                 <Whyattend />
//                 {/* <KeyFuturesSectionVR /> */}
//                 {/* <LearningPathVR /> */}
//                 {/* <LearningPathDommy /> */}
//                 <ProgramFeesAndSchedules />
//                 <SkilledUniversitiesVR />
//                 <ToolCoveredImgesVR />
//               </div>
//             )}
//             {mainTab === 5 && (
//               <div ref={contentRef} className="show-the-content">
//                 {/* Virtual Robotics - Workshop */}
//                 {/* <WorkshoapBanner /> */}
//                 {/* <Vurtualroboticsdata /> */}
//                 {/* <Toolfixturebanner/> */}
//                 {/* <VirtualwebibarKeyfetures /> */}
//                 <TollkeyFeatuare/>
//                <ToolfixtureModule/>
//                 {/* <LearningPathDommy /> */}
//                 <Whyshudattandtool />
//                 <Whatwillgaintool />
//                 <Whowastoattandtool />
//                 <ToolCoveredImgesVR />
//                 {/* <CertificationVR /> */}
//               </div>
//             )}
//             {mainTab === 3 && (
//               <div ref={contentRef} className="show-the-content">
//                 {/* Virtual Robotics - Certification */}
//                 {/* <VirtualroboticscertificationBanner /> */}
//                 {/* <Digitalfactory/> */}
//                 {/* <Vurtualroboticsdata /> */}
//                 {/* < VirtualwebibarKeyfetures /> */}
//                 <Digitalkey/>
//                 <ModuleFactory/>
//                 {/* <LearningPathDommy /> */}
//                 <Digitalwhyshudattand />
//                 <Whatwillgaindigital />
//                 <Whowasattanddigital />
//                 <ToolCoveredImgesVR />
//                 {/* <CertificationVR /> */}
//                 {/* <VrCertificationcode /> */}
//               </div>
//             )}
//             {mainTab === 2 && subTab === 4 && (
//               <div ref={contentRef} className="show-the-content">
//                 {/* Virtual Robotics - Internship */}
//                 {/* <Vurtualroboticsdata /> */}
//                 <VirtualRobotsBannerInternship />
//                 <KeyFuturesSectionVR />
//                 <LearningPathVR />
//                 <ProgramFeesAndSchedules />
//                 <SkilledUniversitiesVR />
//                 <ToolCoveredImgesVR />
//                 <VrCertificationInternship />
//               </div>
//             )}





//             {/* Content Sections - Main Tab 3 (Digital Factory Solution) */}

//           </div>

//         </div>



//       </div>

//       <style>
//         {`
//             .show-the-content {
//               display: block;
//             }

//             .dont-show-content {
//               display: none;
//             }

//             h1, h2, h3, h4, h5, h6, p {
//               font-family: urbanist, serif;
//             }

//             .reCreateTabs ul {
//               display: flex;
//               justify-content: center;
//               list-style: none;
//               padding: 0;
//               margin: 0;
//               flex-wrap: wrap;
//             }

//             .reCreateTabs ul li {
//               display: inline-block;
//               padding: 10px 20px;
//               font-size: 16px;
//               background-color: black;
//               border-radius: 10px;
//               color: white;
//               margin: 5px;
//               cursor: pointer;
//               text-align: center;
//             }

//             .reCreateTabs ul li:hover {
//               color: orange;
//               background-color: gray;
//             }

//             /* Responsive Styles */
//             @media (max-width: 768px) {
//               .reCreateTabs ul li {
//                 font-size: 14px;
//                 padding: 8px 15px;
//               }
//             }

//             @media (max-width: 480px) {
//               .reCreateTabs ul li {
//                 font-size: 12px;
//                 padding: 6px 10px;
//               }

//               .reCreateTabs ul {
//                 flex-direction: column;
//                 // align-items: center;
//               }
//             }

//              @media (max-width: 600px) {
//     .reCreateTabs ul {
//       flex-direction: column; /* Stack tabs vertically on small screens */
//       padding: 0; /* Remove any extra padding */
//     }

//     .reCreateTabs ul li {
//       font-size: 18px !important; /* Make the font smaller */
//       padding: 16px 15px !important; /* Reduce padding to make the tab smaller */
//     }
//   }

// ul {
//   list-style-type: none; /* Removes bullet points */
//   margin: 0; /* Removes any default margin */
//   padding: 0; /* Removes any default padding */
// }


              
//         `}
//       </style>
//     </div>

//   );
// };

// export default PCMobileApplications;





// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import mechImg from "../img/aaaservices/TOOL & FIXTURE V5.jpg";
// import cadImg from "../img/aaaservices/TOOL & FIXTURE V5.jpg";
// import robotImg from "../img/aaaservices/TOOL & FIXTURE V5.jpg";
// import factoryImg from "../img/aaaservices/TOOL & FIXTURE V5.jpg";

// const data = {
//   Mechanical: [
//     { title: "Virtual Robotics", image: robotImg, link: "/robotics" },
//     { title: "CAD Design", image: cadImg, link: "/cad" },
//     { title: "Digital Factory", image: factoryImg, link: "/factory" },
//   ],
//   IT: [
//     { title: "AI Programming", image: mechImg, link: "/ai" },
//     { title: "Cloud Tools", image: cadImg, link: "/cloud" },
//     { title: "Web Dev", image: robotImg, link: "/web" },
//   ],
//   Robotics: [
//     { title: "Motion Sensors", image: mechImg, link: "/motion" },
//     { title: "Drone Tech", image: cadImg, link: "/drones" },
//     { title: "Automation", image: factoryImg, link: "/automation" },
//   ],
//   Design: [
//     { title: "UX Design", image: cadImg, link: "/ux" },
//     { title: "3D Modeling", image: robotImg, link: "/3d" },
//     { title: "AR/VR", image: factoryImg, link: "/arvr" },
//   ],
// };

// const FilterSection = () => {
//   const [selected, setSelected] = useState("Mechanical");
//   const navigate = useNavigate();

//   return (
//     <div style={{ padding: "20px", fontFamily: "sans-serif" }}>
//       <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
//         {Object.keys(data).map((cat) => (
//           <button
//             key={cat}
//             onClick={() => setSelected(cat)}
//             style={{
//               padding: "10px 16px",
//               border: "none",
//               borderRadius: "6px",
//               backgroundColor: selected === cat ? "#f84464" : "#eee",
//               color: selected === cat ? "#fff" : "#333",
//               cursor: "pointer",
//               fontWeight: "bold",
//             }}
//           >
//             {cat}
//           </button>
//         ))}
//       </div>

//       {/* Side Filter Panel */}
//       <div style={{ marginTop: "30px", display: "flex", gap: "30px", flexWrap: "wrap" }}>
//         <div style={{ minWidth: "180px" }}>
//           <h3 style={{ marginBottom: "10px", color: "#f84464" }}>{selected} Filters</h3>
//           {data[selected].map((item, idx) => (
//             <div
//               key={idx}
//               style={{
//                 marginBottom: "10px",
//                 padding: "8px 12px",
//                 backgroundColor: "#f2f2f2",
//                 borderRadius: "5px",
//               }}
//             >
//               {item.title}
//             </div>
//           ))}
//         </div>

//         {/* Cards */}
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//             gap: "20px",
//             flex: 1,
//           }}
//         >
//           {data[selected].map((card, idx) => (
//             <div
//               key={idx}
//               onClick={() => navigate(card.link)}
//               style={{
//                 cursor: "pointer",
//                 backgroundColor: "#fff",
//                 borderRadius: "12px",
//                 boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
//                 overflow: "hidden",
//                 transition: "transform 0.3s",
//               }}
//             >
//               <img
//                 src={card.image}
//                 alt={card.title}
//                 style={{ width: "100%", height: "180px", objectFit: "cover" }}
//               />
//               <div style={{ padding: "12px", fontWeight: "bold", textAlign: "center" }}>{card.title}</div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FilterSection;



// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import mechImg from "../img/aaaservices/TOOL & FIXTURE V5.jpg";
// import cadImg from "../img/aaaservices/TOOL & FIXTURE V5.jpg";
// import robotImg from "../img/aaaservices/TOOL & FIXTURE V5.jpg";
// import factoryImg from "../img/aaaservices/TOOL & FIXTURE V5.jpg";

// const data = {
//   TecTaks: [
//     {
//       title: "Virtual Robotics",
//       name: "John Doe",
//       subtitle: "Simulated Automation",
//       date: "2025-06-01",
//       time: "10:00 AM - 4:00 PM",
//       cost: "₹150",
//       image: robotImg,
//       link: "/filterpage",
//     },
//     {
//       title: "CAD Design",
//       name: "Jane Smith",
//       subtitle: "3D Product Design",
//       date: "2025-06-05",
//       time: "11:00 AM - 5:00 PM",
//       cost: "₹120",
//       image: cadImg,
//       link: "/cad",
//     },
//     {
//       title: "Digital Factory",
//       name: "Mike Johnson",
//       subtitle: "Smart Production",
//       date: "2025-06-10",
//       time: "9:00 AM - 3:00 PM",
//       cost: "₹180",
//       image: factoryImg,
//       link: "/factory",
//     },
//   ],
//   Programs: [
//     {
//       title: "AI Programming",
//       name: "Arjun Rai",
//       subtitle: "Intro to Machine Learning",
//       date: "2025-06-02",
//       time: "10:00 AM - 2:00 PM",
//       cost: "Free",
//       image: mechImg,
//       link: "/ai",
//     },
//     {
//       title: "Web Dev",
//       name: "Priya Kumar",
//       subtitle: "Full-stack Bootcamp",
//       date: "2025-06-03",
//       time: "1:00 PM - 6:00 PM",
//       cost: "₹500",
//       image: robotImg,
//       link: "/web",
//     },
//     {
//       title: "Web Dev",
//       name: "Priya Kumar",
//       subtitle: "Full-stack Bootcamp",
//       date: "2025-06-03",
//       time: "1:00 PM - 6:00 PM",
//       cost: "₹500",
//       image: robotImg,
//       link: "/web",
//     },
//   ],
//   Jobs: [
//     {
//       title: "Motion Sensors",
//       name: "Anil Yadav",
//       subtitle: "Sensor Technology",
//       date: "2025-06-04",
//       time: "9:00 AM - 2:00 PM",
//       cost: "₹250",
//       image: cadImg,
//       link: "/motion",
//     },
//     {
//       title: "Drone Tech",
//       name: "Ravi Kumar",
//       subtitle: "Building Drones",
//       date: "2025-06-07",
//       time: "10:00 AM - 3:00 PM",
//       cost: "₹350",
//       image: robotImg,
//       link: "/drones",
//     },
//     {
//       title: "Automation",
//       name: "Suresh Reddy",
//       subtitle: "Automated Systems",
//       date: "2025-06-08",
//       time: "9:00 AM - 5:00 PM",
//       cost: "₹200",
//       image: factoryImg,
//       link: "/automation",
//     },
//   ],
//   WalkingDrive: [
//     {
//       title: "UX Design",
//       name: "Alok Verma",
//       subtitle: "User Experience Design",
//       date: "2025-06-09",
//       time: "11:00 AM - 4:00 PM",
//       cost: "₹400",
//       image: cadImg,
//       link: "/ux",
//     },
//     {
//       title: "3D Modeling",
//       name: "Sanjay Mehta",
//       subtitle: "Creating 3D Models",
//       date: "2025-06-12",
//       time: "10:00 AM - 2:00 PM",
//       cost: "₹300",
//       image: robotImg,
//       link: "/3d",
//     },
//     {
//       title: "AR/VR",
//       name: "Manoj Singh",
//       subtitle: "Augmented & Virtual Reality",
//       date: "2025-06-15",
//       time: "1:00 PM - 6:00 PM",
//       cost: "₹500",
//       image: factoryImg,
//       link: "/arvr",
//     },
    
//   ],
  
// };

// const FilterSection = () => {
//   const [selected, setSelected] = useState("TecTaks");
//   const [dateFilter, setDateFilter] = useState("");
//   const [calendarDate, setCalendarDate] = useState("");
//   const [location, setLocation] = useState("");
//   const [language, setLanguage] = useState("");
//   const [price, setPrice] = useState("");

//   const navigate = useNavigate();

//   return (
//     <div style={{ padding: "20px", fontFamily: "sans-serif" }}>
//       {/* Category Buttons */}
//       <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
//         {Object.keys(data).map((cat) => (
//           <button
//             key={cat}
//             onClick={() => setSelected(cat)}
//             style={{
//               padding: "10px 16px",
//               border: "none",
//               borderRadius: "24px",
//               backgroundColor: selected === cat ? "blue" : "#eee",
//               color: selected === cat ? "#fff" : "#333",
//               cursor: "pointer",
//               fontWeight: "bold",
//             }}
//           >
//             {cat}
//           </button>
//         ))}
//       </div>

//       {/* Main Content */}
//       <div style={{ marginTop: "30px", display: "flex", gap: "30px", flexWrap: "wrap" }}>
//         {/* Sidebar Filters */}
//         <div style={{ minWidth: "220px" }}>
//           {/* <h3 style={{ marginBottom: "15px", color: "#f84464" }}>{selected} Filters</h3> */}

//           {/* Date Filter */}
//           <div style={{ marginBottom: "15px" }}>
//           <select
//   value={dateFilter}
//   onChange={(e) => setDateFilter(e.target.value)}
//   style={{ width: "100%", padding: "8px", borderRadius: "4px", marginTop: "5px" }}
// >
//   <option value="" disabled hidden>
//     Branches
//   </option>
//   <option value="mechanical">Mechanical Engineering</option>
//   <option value="it">Information Technology</option>
//   <option value="factory">Digital Factory Solution</option>
// </select>

//             <select
//               value={dateFilter}
//               onChange={(e) => setDateFilter(e.target.value)}
//               style={{ width: "100%", padding: "8px", borderRadius: "4px", marginTop: "5px" }}
//             >
//               <option value="">Date</option>
//               <option value="today">Today</option>
//               <option value="tomorrow">Tomorrow</option>
//               <option value="weekend">This Weekend</option>
//             </select>
//             <div style={{ marginTop: "8px" }}>
//               <input
//                 type="date"
//                 value={calendarDate}
//                 onChange={(e) => setCalendarDate(e.target.value)}
//                 style={{ width: "100%", padding: "8px", borderRadius: "4px" }}
//               />
//             </div>
//           </div>

//           {/* Location Filter */}
//           <div style={{ marginBottom: "15px" }}>
            
//             <select
//               value={location}
//               onChange={(e) => setLocation(e.target.value)}
//               style={{ width: "100%", padding: "8px", borderRadius: "4px", marginTop: "5px" }}
//             >
//               <option value="">Location</option>
//               <option value="hyderabad">Hyderabad</option>
//               <option value="bangalore">Bangalore</option>
//               <option value="chennai">Chennai</option>
//               <option value="mumbai">Mumbai</option>
//             </select>
//           </div>

//           {/* Language Filter */}
//           <div style={{ marginBottom: "15px" }}>
           
//             <select
//               value={language}
//               onChange={(e) => setLanguage(e.target.value)}
//               style={{ width: "100%", padding: "8px", borderRadius: "4px", marginTop: "5px" }}
//             >
//               <option value="">Language</option>
//               <option value="english">English</option>
//               <option value="hindi">Hindi</option>
//               <option value="telugu">Telugu</option>
//               <option value="tamil">Tamil</option>
//             </select>
//           </div>

//           {/* Price Filter */}
//           <div style={{ marginBottom: "20px" }}>
           
//             <select
//               value={price}
//               onChange={(e) => setPrice(e.target.value)}
//               style={{ width: "100%", padding: "8px", borderRadius: "4px", marginTop: "5px" }}
//             >
//               <option value="">Price</option>
//               <option value="free">Free</option>
//               <option value="99">₹99</option>
//               <option value="500">₹500</option>
//             </select>
//           </div>

//           {/* Book Button */}
          
// </div>  {/* Cards Section */}
//     <div
//       style={{
//         display: "grid",
//         gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//         gap: "20px",
//         flex: 1,
//       }}
//     >
//       {data[selected].map((card, idx) => (
//         <div
//           key={idx}
//           onClick={() => navigate(card.link)}
//           style={{
//             cursor: "pointer",
//             backgroundColor: "#fff",
//             borderRadius: "12px",
//             boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
//             overflow: "hidden",
//             transition: "transform 0.3s",
//             height:'325px'
//           }}
//         >
//           <img
//             src={card.image}
//             alt={card.title}
//             style={{ width: "100%", height: "180px", objectFit: "cover" }}
//           />
//           <div style={{ padding: "12px", textAlign: "center" }}>
//             <div style={{ fontWeight: "bold" }}>{card.title}</div>
//             <div style={{ fontSize: "14px", color: "#666" }}>{card.subtitle}</div>
//             <div style={{ fontSize: "13px", marginTop: "5px" }}>{card.date} | {card.time}</div>
//             <div style={{ fontSize: "14px", fontWeight: "bold", color: "#f84464", marginTop: "4px" }}>
//               {card.cost}
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   </div>
// </div>
// );
// };

// export default FilterSection;





import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import mechImg from "../Component/vr-picture1.jpg";
import cadImg from "../img/aaaservices/TOOL & FIXTURE V5.jpg";
import robotImg from "../img/aaaservices/TOOL & FIXTURE V5.jpg";
import factoryImg from "../img/aaaservices/TOOL & FIXTURE V5.jpg";
import simImg from '../Component/tool-and-die-maker-6.jpg';
import dfsImg from '../img/aaaservices/smart-factory-blog-image-1.webp';

import itImg from '../img/aaaservices/java-full-stack.webp';
import itImg1 from '../img/aaaservices/python3.webp';
import itImg2 from '../img/aaaservices/app-development-banner_33099-1720.avif';

import dfsImg1 from '../img/aaaservices/Thumbnail-Skill-Based-Professions-1.png';
import dfsImg2 from '../img/aaaservices/s.png';
import dfsImg3 from '../img/aaaservices/d.webp';
const data = {
  TecTaks: [
    {
      title: "Virtual Robotics",
      name: "John Doe",
      subtitle: "Simulated Automation",
      date: "2025-06-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹150",
      image: robotImg,
      link: "/filterpage",
    },
     {
      title: "Virtual Robotics",
      name: "John Doe",
      subtitle: "Simulated Automation",
      date: "2025-06-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹150",
      image: robotImg,
      link: "/filterpage",
    },
     {
      title: "Virtual Robotics",
      name: "John Doe",
      subtitle: "Simulated Automation",
      date: "2025-06-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹150",
      image: robotImg,
      link: "/filterpage",
    },
     {
      title: "Virtual Robotics",
      name: "John Doe",
      subtitle: "Simulated Automation",
      date: "2025-06-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹150",
      image: robotImg,
      link: "/filterpage",
    },
     {
      title: "Virtual Robotics",
      name: "John Doe",
      subtitle: "Simulated Automation",
      date: "2025-06-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹150",
      image: robotImg,
      link: "/filterpage",
    },
     {
      title: "Virtual Robotics",
      name: "John Doe",
      subtitle: "Simulated Automation",
      date: "2025-06-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹150",
      image: robotImg,
      link: "/filterpage",
    },
     {
      title: "Virtual Robotics",
      name: "John Doe",
      subtitle: "Simulated Automation",
      date: "2025-06-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹150",
      image: robotImg,
      link: "/filterpage",
    },
     {
      title: "Virtual Robotics",
      name: "John Doe",
      subtitle: "Simulated Automation",
      date: "2025-06-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹150",
      image: robotImg,
      link: "/filterpage",
    },
     {
      title: "Virtual Robotics",
      name: "John Doe",
      subtitle: "Simulated Automation",
      date: "2025-06-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹150",
      image: robotImg,
      link: "/filterpage",
    },
     {
      title: "Virtual Robotics",
      name: "John Doe",
      subtitle: "Simulated Automation",
      date: "2025-06-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹150",
      image: robotImg,
      link: "/filterpage",
    },
     {
      title: "Virtual Robotics",
      name: "John Doe",
      subtitle: "Simulated Automation",
      date: "2025-06-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹150",
      image: robotImg,
      link: "/filterpage",
    },
     {
      title: "Virtual Robotics",
      name: "John Doe",
      subtitle: "Simulated Automation",
      date: "2025-06-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹150",
      image: robotImg,
      link: "/filterpage",
    },
     {
      title: "Virtual Robotics",
      name: "John Doe",
      subtitle: "Simulated Automation",
      date: "2025-06-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹150",
      image: robotImg,
      link: "/filterpage",
    },
     {
      title: "Virtual Robotics",
      name: "John Doe",
      subtitle: "Simulated Automation",
      date: "2025-06-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹150",
      image: robotImg,
      link: "/filterpage",
    },
     {
      title: "Virtual Robotics",
      name: "John Doe",
      subtitle: "Simulated Automation",
      date: "2025-06-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹150",
      image: robotImg,
      link: "/filterpage",
    },
    {
      title: "Tool & fixture design",
      name: "Jane Smith",
      subtitle: "3D Product Design",
      date: "2025-06-05",
      time: "11:00 AM - 5:00 PM",
      cost: "₹120",
      image: cadImg,
      link: "/cad",
    },
    {
      title: "Digital Factory",
      name: "Mike Johnson",
      subtitle: "Smart Production",
      date: "2025-06-10",
      time: "9:00 AM - 3:00 PM",
      cost: "₹180",
      image: factoryImg,
      link: "/factory",
    },
  ],
  Programs: [
    {
      title: "AI Programming",
      name: "Arjun Rai",
      subtitle: "Intro to Machine Learning",
      date: "2025-06-02",
      time: "10:00 AM - 2:00 PM",
      cost: "Free",
      image: mechImg,
      link: "/ai",
    },
    {
      title: "Web Dev",
      name: "Priya Kumar",
      subtitle: "Full-stack Bootcamp",
      date: "2025-06-03",
      time: "1:00 PM - 6:00 PM",
      cost: "₹500",
      image: robotImg,
      link: "/web",
    },
    {
      title: "Web Dev",
      name: "Priya Kumar",
      subtitle: "Full-stack Bootcamp",
      date: "2025-06-03",
      time: "1:00 PM - 6:00 PM",
      cost: "₹500",
      image: robotImg,
      link: "/web",
    },
  ],
  Jobs: [
    {
      title: "Motion Sensors",
      name: "Anil Yadav",
      subtitle: "Sensor Technology",
      date: "2025-06-04",
      time: "9:00 AM - 2:00 PM",
      cost: "₹250",
      image: cadImg,
      link: "/motion",
    },
    {
      title: "Drone Tech",
      name: "Ravi Kumar",
      subtitle: "Building Drones",
      date: "2025-06-07",
      time: "10:00 AM - 3:00 PM",
      cost: "₹350",
      image: robotImg,
      link: "/drones",
    },
    {
      title: "Automation",
      name: "Suresh Reddy",
      subtitle: "Automated Systems",
      date: "2025-06-08",
      time: "9:00 AM - 5:00 PM",
      cost: "₹200",
      image: factoryImg,
      link: "/automation",
    },
  ],
  WalkingDrive: [
    {
      title: "UX Design",
      name: "Alok Verma",
      subtitle: "User Experience Design",
      date: "2025-06-09",
      time: "11:00 AM - 4:00 PM",
      cost: "₹400",
      image: cadImg,
      link: "/ux",
    },
    {
      title: "3D Modeling",
      name: "Sanjay Mehta",
      subtitle: "Creating 3D Models",
      date: "2025-06-12",
      time: "10:00 AM - 2:00 PM",
      cost: "₹300",
      image: robotImg,
      link: "/3d",
    },
    {
      title: "AR/VR",
      name: "Manoj Singh",
      subtitle: "Augmented & Virtual Reality",
      date: "2025-06-15",
      time: "1:00 PM - 6:00 PM",
      cost: "₹500",
      image: factoryImg,
      link: "/arvr",
    },
  ],
};

const branchesData = {
  mechanical: [
    {
      title: "Robotics & Virtual Simulation",
     
      date: "2025-06-16",
      time: "10:00 AM - 4:00 PM",
      mode: 'Offline',
      cost: "₹250",
      image: mechImg,
      link: '/Virtualpage',
    },
    {
      title: "Tool & Fixture Design",
   
      date: "2025-06-18",
      time: "11:00 AM - 3:00 PM",
      cost: "₹200",
      image: simImg,
      link: "/fixture",
    },
    {
      title: "Digital Factory Solutions",
   
      date: "2025-06-18",
      time: "11:00 AM - 3:00 PM",
      cost: "₹200",
      image: dfsImg,
      link: "/DigitalC",
    },
    
    
  ],
  it: [
    {
      title: "Java Full-Stack-Devlopers",
     
      date: "2025-06-17",
      time: "1:00 PM - 6:00 PM",
      cost: "₹350",
      image: itImg,
      link: "/it-services",
    },
    {
      title: "Python Full-Stack-Devlopers",
     
      date: "2025-06-19",
      time: "10:00 AM - 2:00 PM",
      cost: "₹300",
      image: itImg1,
      link: "/Puthonpage",
    },
    {
      title: "React & Flutter-Devlopers",
    
      date: "2025-06-19",
      time: "10:00 AM - 2:00 PM",
      cost: "₹300",
      image: itImg2,
      link: "/Reactpage",
    },
  ],
  factory: [
    {
      title: "Career foundation Skills",
      
      date: "2025-06-21",
      time: "10:00 AM - 4:00 PM",
      cost: "₹400",
      image:  dfsImg1,
      link: "/Outdoor",
    },
    {
      title: "Soft Skill Enhancements",
     
      date: "2025-06-22",
      time: "9:00 AM - 1:00 PM",
      cost: "₹450",
      image: dfsImg2,
      link: "/Sopftskillpage",
    },
    {
      title: "Digital Presence Skills",
     
      date: "2025-06-22",
      time: "9:00 AM - 1:00 PM",
      cost: "₹450",
      image: dfsImg3 ,
      link: "/Digitalpresenceskillpage",
    },
  ],
};


const FilterSection = () => {
  const [selected, setSelected] = useState("TecTaks");
  const [branch, setBranch] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const [calendarDate, setCalendarDate] = useState("");
  const [location, setLocation] = useState("");
  const [language, setLanguage] = useState("");
  const [price, setPrice] = useState("");
  const navigate = useNavigate();

  return (
    <div style={{ padding: "20px", fontFamily: "sans-serif" }}>
      {/* Category Buttons */}
      <div
  style={{
    position: "sticky",
    top: "83px", // adjust according to your navbar height
    zIndex: 999,
    backgroundColor: "#fff",
    padding: "10px 20px",
    // boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  }}
>
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      gap: "20px",
      flexWrap: "wrap",
    }}
  >
    {Object.keys(data).map((cat) => (
      <button
        key={cat}
        onClick={() => {
          setSelected(cat);
          setBranch("");
        }}
        style={{
          padding: "10px 16px",
          border: "none",
          borderRadius: "24px",
          backgroundColor: selected === cat && !branch ? "blue" : "#eee",
          color: selected === cat && !branch ? "#fff" : "#333",
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        {cat}
      </button>
    ))}
  </div>
</div>


      {/* Main Content */}
      <div style={{ display: "flex", gap: "30px", marginTop: "30px", padding: "0 20px" }}>
  {/* Left Sticky Sidebar */}
  <div
    style={{
      minWidth: "220px",
      position: "sticky",
      top: "100px", // Adjust this based on your header height
      alignSelf: "flex-start",
      background: "#fff",
      padding: "15px",
      borderRadius: "8px",
      boxShadow: "0 0 10px rgba(0,0,0,0.1)"
    }}
  >
    {/* Branch Filter */}
    <div style={{ marginBottom: "15px" }}>
      <select
        value={branch}
        onChange={(e) => setBranch(e.target.value)}
        style={{ width: "100%", padding: "8px", borderRadius: "4px", marginTop: "5px" }}
      >
        <option value="">Branches</option>
        <option value="mechanical">Mechanical Engineering</option>
        <option value="it">Information Technology</option>
        <option value="factory">Digital Factory Solution</option>
      </select>
    </div>

    {/* Date Filter */}
    <div style={{ marginBottom: "15px" }}>
      <select
        value={dateFilter}
        onChange={(e) => setDateFilter(e.target.value)}
        style={{ width: "100%", padding: "8px", borderRadius: "4px" }}
      >
        <option value="">Date</option>
        <option value="today">Today</option>
        <option value="tomorrow">Tomorrow</option>
        <option value="weekend">This Weekend</option>
      </select>
      <div style={{ marginTop: "8px" }}>
        <input
          type="date"
          value={calendarDate}
          onChange={(e) => setCalendarDate(e.target.value)}
          style={{ width: "100%", padding: "8px", borderRadius: "4px" }}
        />
      </div>
    </div>

    {/* Location Filter */}
    <div style={{ marginBottom: "15px" }}>
      <select
        value={location}
        onChange={(e) => setLocation(e.target.value)}
        style={{ width: "100%", padding: "8px", borderRadius: "4px" }}
      >
        <option value="">Location</option>
        <option value="hyderabad">Hyderabad</option>
        <option value="bangalore">Bangalore</option>
        <option value="chennai">Chennai</option>
        <option value="mumbai">Mumbai</option>
      </select>
    </div>

    {/* Language Filter */}
    <div style={{ marginBottom: "15px" }}>
      <select
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
        style={{ width: "100%", padding: "8px", borderRadius: "4px" }}
      >
        <option value="">Language</option>
        <option value="english">English</option>
        <option value="hindi">Hindi</option>
        <option value="telugu">Telugu</option>
        <option value="tamil">Tamil</option>
      </select>
    </div>

    {/* Price Filter */}
    <div style={{ marginBottom: "20px" }}>
      <select
        value={price}
        onChange={(e) => setPrice(e.target.value)}
        style={{ width: "100%", padding: "8px", borderRadius: "4px" }}
      >
        <option value="">Price</option>
        <option value="free">Free</option>
        <option value="99">₹99</option>
        <option value="500">₹500</option>
      </select>
    </div>
  </div>

  {/* Main Content Area */}
  {/* <div style={{ flex: 1 }}> */}
    {/* Place your cards or filtered results here */}
    {/* Example: <CardList data={filteredCards} /> */}
  



        {/* Cards Section */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "20px",
            flex: 1,
          }}
        >
          {(branch ? branchesData[branch] : data[selected]).map((card, idx) => (
            <div
              key={idx}
              onClick={() => navigate(card.link)}
              style={{
                cursor: "pointer",
                backgroundColor: "#fff",
                borderRadius: "12px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                overflow: "hidden",
                transition: "transform 0.3s",
                height: "365px",
              }}
            >
              <img
                src={card.image}
                alt={card.title}
                style={{ width: "100%", height: "207px", objectFit: "cover",padding:'11px',borderRadius:'20px' }}
              />
              <div style={{ padding: "12px", textAlign: "left" }}>
                <div style={{ fontWeight: "bold",fontSize:"20px",color:"blue",fontFamily:'roboto', textAlign:'center', }}>{card.title}</div>

                 <div style={{ fontSize: "17px", color: "black",fontWeight:'bold',fontFamily:'roboto' }}>{card.name}</div>
                  <div style={{fontSize: "17px", color: "black",fontWeight:'bold',fontFamily:'roboto' }}>{card.mode}</div>
                <div style={{fontSize: "17px", color: "BLACK",fontWeight:'bold',fontFamily:'roboto', marginTop: "5px" }}>{card.date} |< br/> {card.time} </div>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "green",
                    marginTop: "4px",
                  }}
                >
                  {card.cost}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FilterSection;





// import React, { useState } from 'react';
// import mechImg from "../Component/vr-picture1.jpg";


// const section1Cards = {
//   Mechanical: [
//     { title: 'Mech Card 1', img: mechImg, link: '/mech1' },
//     { title: 'Mech Card 2', img: mechImg, link: '/mech2' },
//     { title: 'Mech Card 3', img: mechImg, link: '/mech3' },
//     { title: 'Mech Card 4', img: mechImg, link: '/mech4' },
//     { title: 'Mech Card 5', img: mechImg, link: '/mech5' },
//     { title: 'Mech Card 6', img: mechImg, link: '/mech6' },
//   ],
//   IT: [
//     { title: 'IT Card 1', img: mechImg, link: '/it1' },
//     { title: 'IT Card 2', img: mechImg, link: '/it2' },
//     { title: 'IT Card 3', img: mechImg, link: '/it3' },
//     { title: 'IT Card 4', img: mechImg, link: '/it4' },
//     { title: 'IT Card 5', img: mechImg, link: '/it5' },
//     { title: 'IT Card 6', img: mechImg, link: '/it6' },
//   ],
//   'Digital Factory': [
//     { title: 'DF Card 1', img: mechImg, link: '/df1' },
//     { title: 'DF Card 2', img: mechImg, link: '/df2' },
//     { title: 'DF Card 3', img: mechImg, link: '/df3' },
//     { title: 'DF Card 4', img: mechImg, link: '/df4' },
//     { title: 'DF Card 5', img: mechImg, link: '/df5' },
//     { title: 'DF Card 6', img: mechImg, link: '/df6' },
//   ]
// };

// const section2Cards = [
//   { title: 'Sec2 Card 1', img: mechImg, link: '/sec2-1' },
//   { title: 'Sec2 Card 2', img: mechImg, link: '/sec2-2' },
//   { title: 'Sec2 Card 3', img: mechImg, link: '/sec2-3' },
//   { title: 'Sec2 Card 4', img: mechImg, link: '/sec2-4' },
//   { title: 'Sec2 Card 5', img: mechImg, link: '/sec2-5' },
//   { title: 'Sec2 Card 6', img:mechImg, link: '/sec2-6' },
// ];

// const section3Cards = [
//   { title: 'Sec3 Card A', img: mechImg, link: '/sec3-a' },
//   { title: 'Sec3 Card B', img: mechImg, link: '/sec3-b' },
//   { title: 'Sec3 Card C', img: mechImg, link: '/sec3-c' },
//   { title: 'Sec3 Card D', img: mechImg, link: '/sec3-d' },
// ];

// const section4Cards = [
//   { title: 'Sec4 Card X', img: mechImg, link: '/sec4-x' },
//   { title: 'Sec4 Card Y', img: mechImg, link: '/sec4-y' },
//   { title: 'Sec4 Card Z', img: mechImg, link: '/sec4-z' },
//   { title: 'Sec4 Card W', img: mechImg, link: '/sec4-w' },
// ];

// const MultiSectionFilter = () => {
//   const [activeSection, setActiveSection] = useState(1);
//   const [selectedBranch, setSelectedBranch] = useState('Mechanical');

//   const renderCards = (cards) => (
//     <div style={cardGridStyle}>
//       {cards.map((card, index) => (
//         <a href={card.link} key={index} style={cardStyle}>
//           <img src={card.img} alt={card.title} style={imgStyle} />
//           <h3>{card.title}</h3>
//         </a>
//       ))}
//     </div>
//   );

//   return (
//     <div style={{ fontFamily: 'sans-serif' }}>
//       {/* Fixed Top Menu */}
//       <div style={topBarStyle}>
//         {[1, 2, 3, 4].map((num) => (
//           <button key={num} onClick={() => setActiveSection(num)} style={topBtnStyle}>
//             Section {num}
//           </button>
//         ))}
//       </div>

//       {/* Section 1 */}
//       {activeSection === 1 && (
//         <div style={{ display: 'flex', marginTop: '60px' }}>
//           <div style={sidebarStyle}>
//             <label htmlFor="branch">Branches</label>
//             <select
//               id="branch"
//               value={selectedBranch}
//               onChange={(e) => setSelectedBranch(e.target.value)}
//               style={dropdownStyle}
//             >
//               <option value="Mechanical">Mechanical</option>
//               <option value="IT">IT</option>
//               <option value="Digital Factory">Digital Factory</option>
//             </select>
//           </div>
//           <div style={contentScrollStyle}>
//             {renderCards(section1Cards[selectedBranch])}
//           </div>
//         </div>
//       )}

//       {/* Section 2 */}
//       {activeSection === 2 && (
//         <div style={sectionContainerStyle}>
//           {renderCards(section2Cards)}
//         </div>
//       )}

//       {/* Section 3 */}
//       {activeSection === 3 && (
//         <div style={sectionContainerStyle}>
//           {renderCards(section3Cards)}
//         </div>
//       )}

//       {/* Section 4 */}
//       {activeSection === 4 && (
//         <div style={sectionContainerStyle}>
//           {renderCards(section4Cards)}
//         </div>
//       )}
//     </div>
//   );
// };

// // Internal Styles
// const topBarStyle = {
//   position: 'fixed', top: 0, left: 0, right: 0,
//   background: '#0055aa', color: 'white', padding: '10px',
//   display: 'flex', justifyContent: 'center', gap: '15px',
//   zIndex: 1000
// };

// const topBtnStyle = {
//   background: 'white', color: '#0055aa',
//   padding: '8px 16px', border: 'none',
//   borderRadius: '5px', cursor: 'pointer'
// };

// const sidebarStyle = {
//   position: 'fixed', top: '60px', left: 0,
//   width: '200px', height: '100vh',
//   background: '#f0f0f0', padding: '20px',
//   zIndex: 999, boxShadow: '2px 0 5px rgba(0,0,0,0.1)'
// };

// const dropdownStyle = {
//   width: '100%', padding: '8px', marginTop: '10px'
// };

// const contentScrollStyle = {
//   marginLeft: '220px', padding: '20px',
//   height: 'calc(100vh - 60px)', overflowY: 'auto', width: '100%'
// };

// const sectionContainerStyle = {
//   marginTop: '80px', padding: '20px'
// };

// const cardGridStyle = {
//   display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
//   gap: '20px'
// };

// const cardStyle = {
//   background: '#fff', padding: '10px', borderRadius: '10px',
//   boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
//   textAlign: 'center', textDecoration: 'none', color: 'black'
// };

// const imgStyle = {
//   width: '100%', height: '130px', objectFit: 'cover',
//   borderRadius: '8px'
// };

// export default MultiSectionFilter;







// import React, { useState } from 'react';
// import mechImg from "../Component/vr-picture1.jpg";

// // Sample card data
// const cardData = {
//   section1: {
//     Mechanical: [...Array(6)].map((_, i) => ({ title: `Mech Card ${i + 1}`, img: mechImg, link: `/mech${i + 1}` })),
//     IT: [...Array(6)].map((_, i) => ({ title: `IT Card ${i + 1}`, img: mechImg, link: `/it${i + 1}` })),
//     'Digital Factory': [...Array(6)].map((_, i) => ({ title: `DF Card ${i + 1}`, img: mechImg, link: `/df${i + 1}` }))
//   },
//   section2: [...Array(6)].map((_, i) => ({ title: `Sec2 Card ${i + 1}`, img: mechImg, link: `/sec2-${i + 1}` })),
//   section3: [...Array(4)].map((_, i) => ({ title: `Sec3 Card ${String.fromCharCode(65 + i)}`, img: mechImg, link: `/sec3-${i}` })),
//   section4: [...Array(4)].map((_, i) => ({ title: `Sec4 Card ${String.fromCharCode(88 + i)}`, img: mechImg, link: `/sec4-${i}` }))
// };

// const MultiSectionFilter = () => {
//   const [activeSection, setActiveSection] = useState(1);
//   const [selectedBranch, setSelectedBranch] = useState('Mechanical');
//   const [dateFilter, setDateFilter] = useState('');
//   const [calendarDate, setCalendarDate] = useState('');
//   const [location, setLocation] = useState('');
//   const [language, setLanguage] = useState('');
//   const [price, setPrice] = useState('');

//   const getCardsForSection = () => {
//     if (activeSection === 1) return cardData.section1[selectedBranch];
//     if (activeSection === 2) return cardData.section2;
//     if (activeSection === 3) return cardData.section3;
//     if (activeSection === 4) return cardData.section4;
//     return [];
//   };

//   return (
//     <div style={outerContainerStyle}>
//       {/* Top Fixed Button Bar */}
//       <div style={topBarStyle}>
//         {['Section 1', 'Section 2', 'Section 3', 'Section 4'].map((label, index) => (
//           <button key={index} onClick={() => setActiveSection(index + 1)} style={topBtnStyle}>
//             {label}
//           </button>
//         ))}
//       </div>

//       {/* Main Content Area with Sidebar + Cards */}
//       <div style={mainContentStyle}>
//         {/* Sidebar */}
//         <div style={sidebarStyle}>
//           <div style={filterGroupStyle}>
//             <label>Branches</label>
//             <select value={selectedBranch} onChange={(e) => setSelectedBranch(e.target.value)} style={dropdownStyle}>
//               <option value="Mechanical">Mechanical</option>
//               <option value="IT">IT</option>
//               <option value="Digital Factory">Digital Factory</option>
//             </select>
//           </div>

//           <div style={filterGroupStyle}>
//             <label>Date</label>
//             <select value={dateFilter} onChange={(e) => setDateFilter(e.target.value)} style={dropdownStyle}>
//               <option value="">Date</option>
//               <option value="today">Today</option>
//               <option value="tomorrow">Tomorrow</option>
//               <option value="weekend">This Weekend</option>
//             </select>
//             <input
//               type="date"
//               value={calendarDate}
//               onChange={(e) => setCalendarDate(e.target.value)}
//               style={{ ...dropdownStyle, marginTop: '8px' }}
//             />
//           </div>

//           <div style={filterGroupStyle}>
//             <label>Location</label>
//             <select value={location} onChange={(e) => setLocation(e.target.value)} style={dropdownStyle}>
//               <option value="">Location</option>
//               <option value="hyderabad">Hyderabad</option>
//               <option value="bangalore">Bangalore</option>
//               <option value="chennai">Chennai</option>
//               <option value="mumbai">Mumbai</option>
//             </select>
//           </div>

//           <div style={filterGroupStyle}>
//             <label>Language</label>
//             <select value={language} onChange={(e) => setLanguage(e.target.value)} style={dropdownStyle}>
//               <option value="">Language</option>
//               <option value="english">English</option>
//               <option value="hindi">Hindi</option>
//               <option value="telugu">Telugu</option>
//               <option value="tamil">Tamil</option>
//             </select>
//           </div>

//           <div style={filterGroupStyle}>
//             <label>Price</label>
//             <select value={price} onChange={(e) => setPrice(e.target.value)} style={dropdownStyle}>
//               <option value="">Price</option>
//               <option value="free">Free</option>
//               <option value="99">₹99</option>
//               <option value="500">₹500</option>
//             </select>
//           </div>
//         </div>

//         {/* Card Area */}
//         <div style={cardContainerStyle}>
//           <div style={cardGridStyle}>
//             {getCardsForSection().slice(0, 4).map((card, index) => (
//               <a key={index} href={card.link} style={cardStyle}>
//                 <img src={card.img} alt={card.title} style={imgStyle} />
//                 <h3>{card.title}</h3>
//               </a>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Styles
// const outerContainerStyle = {
//   border: '1px solid #ccc',
//   width: '100%',
//   height: 'calc(100vh - 60px)',
//   overflow: 'hidden',
//   position: 'relative',
//   fontFamily: 'sans-serif'
// };

// const topBarStyle = {
//   position: 'sticky',
//   top: 0,
//   background: '#fff',
//   padding: '10px 0',
//   display: 'flex',
//   justifyContent: 'center',
//   gap: '15px',
//   zIndex: 1000,
//   borderBottom: '1px solid #ddd'
// };

// const topBtnStyle = {
//   padding: '10px 20px',
//   background: '#0055aa',
//   color: '#fff',
//   border: 'none',
//   borderRadius: '5px',
//   cursor: 'pointer',
//   fontWeight: 'bold'
// };

// const mainContentStyle = {
//   display: 'flex',
//   height: '100%',
//   overflow: 'hidden'
// };

// const sidebarStyle = {
//   width: '280px',
//   background: '#f7f7f7',
//   padding: '20px',
//   overflowY: 'auto',
//   borderRight: '1px solid #ccc'
// };

// const filterGroupStyle = {
//   marginBottom: '20px'
// };

// const dropdownStyle = {
//   width: '100%',
//   padding: '8px',
//   borderRadius: '5px',
//   border: '1px solid #ccc'
// };

// const cardContainerStyle = {
//   flex: 1,
//   padding: '20px',
//   overflowY: 'auto'
// };

// const cardGridStyle = {
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '20px'
// };

// const cardStyle = {
//   background: '#fff',
//   padding: '15px',
//   borderRadius: '10px',
//   boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
//   textAlign: 'center',
//   textDecoration: 'none',
//   color: '#333'
// };

// const imgStyle = {
//   width: '100%',
//   height: '150px',
//   objectFit: 'cover',
//   borderRadius: '8px',
//   marginBottom: '10px'
// };

// export default MultiSectionFilter;
